import React, { useContext } from 'react';
import BSSDataContext from '../../contexts/BSSDataContext';
import { retrieveNazioni } from '../../api/tnazioni';
import __t from '../../lib/traduzioni';
import BSSAutocomplete from "../form/BSSAutocomplete";
import BSSPreventivoContext from '../../contexts/BSSPreventivoContext';

const countryToFlag = (iso) => String.fromCodePoint === undefined ? iso : 
        iso.toUpperCase().replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397));

const CercaNazione = ({name, methods, nazioni}) => {

    const {isodefault} = useContext(BSSDataContext)

    return (
        <BSSAutocomplete 
            name={name}
            label={__t("nazione")}
            methods={methods}
            dataProvider={async () => {                
                return [nazioni.find(n => n.iso === isodefault), ...nazioni.filter(n => n.iso !== isodefault)];
            }}            
            ControllerProps={{rules: {required: __t("validazione.requiredField", [__t("nazione")])}}}
            AutocompleteProps={{
                getOptionLabel: (option) => option.nazione,
                renderOption: (props, option, { selected }) => (
                    <li {...props}>
                        <div>{countryToFlag(option.iso)} {option.nazione}</div>                                    
                    </li>
                )                
            }}
        />
    )
}

export default CercaNazione;
export {countryToFlag}
